var $ = require('jquery');

var $header = $('#header');
// Nav Fixed
$(window).on('scroll', function() {
    if ($(window).scrollTop() > 300) {
        $header.addClass('is-fixed');
    } else {
        $header.removeClass('is-fixed');
    }
});


//背景色
$('[data-color="black"]').on('click', function(){
  if (sessionStorage.fontColor !== 'black') {
    $('html').addClass('black');
    $('html').removeClass('white');
    $('html').removeClass('yellow');
    sessionStorage.fontColor = 'black';
  } 
});

$('[data-color="white"]').on('click', function(){
  if (sessionStorage.fontColor !== 'white') {
    $('html').addClass('white');
    $('html').removeClass('black');
    $('html').removeClass('yellow');
    sessionStorage.fontColor = 'white';
  }
});

$('[data-color="yellow"]').on('click', function(){
  if (sessionStorage.fontColor !== 'yellow') {
    $('html').addClass('yellow');
    $('html').removeClass('black');
    $('html').removeClass('white');
    sessionStorage.fontColor = 'yellow';
  }
});

if (sessionStorage.fontColor === 'black') {
  $('html').addClass('black');
  $('html').removeClass('white');
  $('html').removeClass('yellow');
} else if (sessionStorage.fontColor === 'white'){
  $('html').addClass('white');
  $('html').removeClass('black');
  $('html').removeClass('yellow');
} else if (sessionStorage.fontColor === 'yellow'){
  $('html').addClass('yellow');
  $('html').removeClass('black');
  $('html').removeClass('white');
}

//文字サイズ
$('[data-font="large"]').on('click', function(){
  if (sessionStorage.fontSize !== 'large') {
    $('html').addClass('large');
    sessionStorage.fontSize = 'large';
  } 
});

$('[data-font="normal"]').on('click', function(){
  if (sessionStorage.fontSize !== 'normal') {
    $('html').removeClass('large');
    sessionStorage.fontSize = 'normal';
  }
});

if (sessionStorage.fontSize === 'large') {
  $('html').addClass('large');
} else if (sessionStorage.fontSize === 'normal'){
  $('html').removeClass('large');
}


//CVボタン
$('div.cv__close').on('click', function(){
  $(this).parent().addClass('is-fire');
});



// Nav Toggle Button
$('#toggle').on('click', function(){
    $header.toggleClass('is-open');
});

$(".sp-toggle").on("click", function() {
    $(this).next().slideToggle();
});

$(".sp-toggle").on("click", function() {
    $(this).toggleClass('is-open');
});